import type {
  GetRelatedPeoplePayload,
  GetRelatedPeopleResult,
} from '@shared/services/caregivers/types/getRelatedPeople.types';
import type { BuilderType } from '@shared/utils/api/configs/rtkBaseQueryDemo';
import { GET_RELATED_PEOPLE } from '@shared/utils/api/configs/URL';
import { hasCcdpSuccess } from '@shared/utils/api/handlers/interpretCcdpCode/interpretCcdpCode';
import type { GenericApiResponse } from '@shared/utils/api/types';

export const TAG_GET_RELATEDPEOPLE = 'getRelatedPeople';

export const getRelatedPeople = (builder: BuilderType) =>
  builder.query<GetRelatedPeopleResult, GetRelatedPeoplePayload>({
    providesTags: [TAG_GET_RELATEDPEOPLE],
    query: (data) => ({
      data,
      isErrMsgConcatErrCode: false,
      method: 'POST',
      url: GET_RELATED_PEOPLE,
    }),
    transformResponse: (response: GenericApiResponse<GetRelatedPeopleResult>) => {
      if (hasCcdpSuccess(response)) {
        return response.Result;
      }

      throw {
        code: response.Code,
        message: response.Message,
      };
    },
  });
